import { OPTIONAL } from './../../constants/constant';
import { FormControl, AbstractControl } from '@angular/forms';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-input-file',
  templateUrl: './input-file.component.html',
  styleUrls: [
    './input-file.component.scss',
    '../input-textbox/input-textbox.component.scss',
  ],
})
export class InputFileComponent implements OnInit {
  @Input() labelName: string;
  @Input() inputFormControl: FormControl;
  @Input() labelTextTransformNone = false;
  @Input() submitted = false;
  @Output() onFileSelect: EventEmitter<any> = new EventEmitter<any>();

  OPTIONAL = OPTIONAL;
  showLoader = false;
  constructor() {}

  ngOnInit(): void {}

  get isRequiredField(): boolean {
    if (!this.inputFormControl.validator) {
      return false;
    }

    const validator = this.inputFormControl.validator({} as AbstractControl);
    return validator && validator.required;
  }

  public onSelect(event): void {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.onFileSelect.emit(file);
    }
  }
}
